<div class="qvs-status-banner">
  <qvs-svg-icon *ngIf="bannerSrc" class="qvs-status-banner__banner" [src]="bannerSrc"></qvs-svg-icon>
  <ng-container *ngIf="iconSrc">
    <qvs-svg-icon *ngIf="rotate" class="qvs-status-banner__icon rotate" [src]="iconSrc"></qvs-svg-icon>
    <qvs-svg-icon *ngIf="!rotate" class="qvs-status-banner__icon" [src]="iconSrc"></qvs-svg-icon>
  </ng-container>
</div>
